import logo from './logo.svg';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ChatDreamCoffee from './Telas/DreamCoffe/ChatDreamCoffee';
// import ChatDreamCoffee from './Telas/DreamCoffe/ChatDreamCoffee';

const theme = createTheme();
function App() {
  return (
    <ThemeProvider theme={theme}>
      <div>
     <ChatDreamCoffee />
      </div>
    </ThemeProvider>
  );
}

export default App;
